<template>
  <el-dialog
    class="dialog-wrapper"
    :visible="true"
    :show-close="false"
    @close="abortAction"
  >
    <ContentHeader
      slot="title"
      :title="modalTitle"
    />
    <ValidationObserver v-slot="{ handleSubmit }">
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <FormItem
              :label="$t('analysesStatusManagement.editLabNotes.notes')"
            >
              <el-input
                type="textarea"
                v-model="labNotes"
                rows="5"
                :disabled="isCompleted"
              />
            </FormItem>
          </el-col>
        </el-row>

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortAction"
          >
            {{ $t('global.cancel') }}
          </el-button>
          <el-button
            v-if="!isCompleted"
            type="primary"
            native-type="submit"
            :disabled="isCompleted"
            @click.prevent="handleSubmit(saveNote)"
          >
            {{ $t('global.confirm') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { samplesApi } from '@/api';
  import { LAB_SAMPLE_STATUSES } from '@/config/constants';
  import FormItem from '@/components/FormItem.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';

  export default {
    name: 'EditLabNote',
    components: {
      FormItem,
      ContentHeader,
      FormButtons,
    },
    props: {
      sample: { type: Object, required: true },
    },
    data() {
      return {
        labNotes: '',
      };
    },
    computed: {
      isCompleted() {
        return this.sample.status === LAB_SAMPLE_STATUSES.COMPLETED;
      },
      modalTitle() {
        return this.isCompleted
          ? this.$t('tableButtons.viewLabNotes')
          : this.$t('analysesStatusManagement.editLabNotes.title');
      },
    },
    watch: {
      sample: {
        handler(newValue) {
          this.labNotes = newValue.labNotes || '';
        },
        immediate: true,
      },
    },
    methods: {
      async saveNote() {
        try {
          await samplesApi.update(this.sample.sampleId, this.labNotes);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('global.success'),
          });
          this.$emit('dialogClose', { success: true, labNotes: this.labNotes });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: this.$t('global.error'),
          });
        }
      },
      abortAction() {
        this.$emit('dialogClose', { success: false });
      },
    },
  };
</script>
